/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для получения сетов подарков за действие
   */
  app.GiftSets = app.Collection.extend({
    url: app.giftServiceUrl + 'set/',
    parse: function (response) {
      return response;
    },
  });
})();

}.call(window));